var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dynamic-banner"},_vm._l((_vm.pageBanners),function(banner){return _c('PageDynamicBannerTemplate1',{key:banner.id,attrs:{"banner":banner,"template":_vm.getBannerTemplate(banner.templateId),"campaign":_vm.getCampaignById(banner.campaignId)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }